import React from 'react';

import { Box, Header, Skeleton, Text } from '@rbilabs/universal-components';

import { ProgressBar } from 'components/progress-bar';
import { primitive } from 'styles/constants/primitives';

import theme from './theme';
import { IFreeDeliveryProgressProps } from './types';

const Container = Box.withConfig({
  alignItems: 'center',
  borderTopWidth: '1px',
  borderTopColor: '#aaaaaa',
  paddingTop: '$4',
  marginTop: '$2.5',
  gap: '$1',
});

const Title = Header.withConfig({
  variant: 'headerThree',
  color: primitive.bk.$crunchyGreen,
  marginBottom: '$0',
});

const SubText = Text.withConfig({
  color: theme.subTextColor,
});

const FreeDeliveryProgress: React.FC<React.PropsWithChildren<IFreeDeliveryProgressProps>> = ({
  isLoading,
  isFreeDelivery,
  freeDeliveryPercentageComplete,
  titleLabel,
  freeDeliveryInProgressLabel,
}) => (
  <Container testID="free-delivery-progress">
    {isLoading ? (
      <>
        <Skeleton height="20px" width="80%" color={Styles.color.grey.four} />
        <Skeleton height="25px" width="full" color={Styles.color.grey.four} />
        <Skeleton height="20px" width="80%" color={Styles.color.grey.four} />
      </>
    ) : (
      <>
        <Title>{titleLabel}</Title>
        {!isFreeDelivery && (
          <>
            <ProgressBar
              percentage={freeDeliveryPercentageComplete}
              fillColor={primitive.bk.$crunchyGreen}
            />
            <SubText>{freeDeliveryInProgressLabel}</SubText>
          </>
        )}
      </>
    )}
  </Container>
);

export default FreeDeliveryProgress;
